import { render, staticRenderFns } from "./WsInfoTulpaSections.vue?vue&type=template&id=b7f63ff8&"
import script from "./WsInfoTulpaSections.vue?vue&type=script&lang=js&"
export * from "./WsInfoTulpaSections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports